import { render, staticRenderFns } from "./BancoImagenProductoModal.vue?vue&type=template&id=5026570d&"
import script from "./BancoImagenProductoModal.vue?vue&type=script&lang=js&"
export * from "./BancoImagenProductoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports